import { Drawer } from "@/components/shared/Drawer";
import { Button } from "@/components/shared/atoms/Button";
import React from "react";

interface VerifyEmailBottomSheetProps {
  open: boolean;
  onClose: () => void;
  onResend: () => void;
  isLoading?: boolean;
  error?: string | null;
  successMessage?: string | null;
}

export const VerifyEmailBottomSheet: React.FC<VerifyEmailBottomSheetProps> = ({
  open,
  onClose,
  onResend,
  isLoading = false,
  error = null,
  successMessage = null,
}) => {
  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      onClose();
    }
  };

  if (!open) return null;

  return (
    <Drawer
      open={open}
      onOpenChange={handleOpenChange}
      triggerContent={null}
      contentClassName="!z-50"
    >
      <div className="bg-white rounded-t-2xl pt-6 max-w-md mx-auto w-full shadow-lg">
        <div className="px-4 text-center">
          <h2 className="text-lg font-semibold text-black">Verify your email</h2>
          <p className="text-sm text-gray-600 mt-2">
            We have sent a verification link to your email address. Please check your inbox and click the link before continuing. Check your spam folder.
          </p>

        </div>

        {/* Success Message */}
        {successMessage && (
          <div className="mx-4 mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
            <p className="text-sm text-green-700">{successMessage}</p>
          </div>
        )}

        {/* Error Message */}
        {error && (
          <div className="mx-4 mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-700">{error}</p>
          </div>
        )}

        <div className="flex flex-col gap-3 px-4 mt-6">
          <Button
            onClick={onResend}
            fullWidth
            variant="solid"
            textColor="white"
            disabled={isLoading}
          >
            {isLoading ? "Sending..." : "Resend verification email"}
          </Button>
          <Button onClick={onClose} fullWidth variant="outline" textColor="black">
            Close
          </Button>
        </div>
      </div>
    </Drawer>
  );
}; 